import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SectionHeaderComponent } from "../../../shared/section-header/section-header.component";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { BankAccount } from "@models/bank-account";
import { isEmpty } from "lodash-es";

@Component({
  selector: "app-card-bank-account",
  imports: [SectionHeaderComponent, NgbTooltipModule],
  templateUrl: "./card-bank-account.component.html",
  styleUrl: "./card-bank-account.component.scss",
})
export class CardBankAccountComponent {
  @Input() account_info: BankAccount | null = null;
  @Input() deleting = false;

  @Output() editBankAccountClick = new EventEmitter<BankAccount | null>();
  @Output() deleteBankAccountClick = new EventEmitter();
  @Output() viewPendingChangesClick = new EventEmitter();

  get hasPendingChanges(): boolean {
    return !isEmpty(this.account_info?.pending_changes);
  }
}
